<template>
    <div class="modal fade" id="feedbackModal" tabindex="-1" role="dialog" aria-labelledby="feedbackModal">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div id="leftDiv">
                    <h1>Your Feedback</h1>
                    <label id="emailLabel">E-Mail : </label>
                    <span id="emailInputSpan"><input id="emailFeedBack" type="text"></span>
                    <textarea id="textArea" rows="30" cols="100" v-on:keyup="onFeedbackTextAreaChanged"/>
                    <br>
                </div>
                <div id="rightDiv">
                    <h1>Related Topics from FAQ</h1>

                    <div id="faq-container">
                        <label id="faqInfo" v-if = "!faqFound">Please enter message to match FAQ</label>
                        <li v-for="faq in relatedFaqs">
                            <label class="question">{{faq.question}}</label>
                            <p class="answer">{{faq.answer}}</p>
                            <br>
                        </li>
                    </div>
                </div>
                <button id="send-feedback-button" class="grow" :disabled="onRequest" @click="sendFeedback">Send Feedback</button>
                <button id="close-button" class="grow" @click="hideModal"> Close </button>
            </div>
        </div>
    </div>
</template>

<script>

    import Constants from '@/utils/constants'
    import {mapGetters} from 'vuex';
    import Common from '@/utils/Common.vue'

    export default {
        name: "feedback",
        mixins: [Common],
        data() {
            return {
                faqFound: false,
                faqs: [],
                relatedFaqs: [],
                feedbackId: null,
                lastContentLength: 0,
                onRequest: false,
                whitelabeling_data: {}
            }
        },
        methods: {
            onFeedbackTextAreaChanged(){
                this.searchFaq();
                this.saveFeedbackLog();
            },
            showModal(){

                this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/enterprise/faq/get')
                    .then(response => {
                        var faqResponse = response.data.data;
                        for(var i=0; i<faqResponse.length; i++){
                            this.faqs[i] = faqResponse[i].question.concat("-").concat(faqResponse[i].answer);
                        }
                    }, response => {
                    });

                $('#emailFeedBack').val('');
                $('#textArea').val('');
                $('#feedbackModal').modal('show');
            },
            hideModal(){
                $('#feedbackModal').modal('hide');
            },
            sendFeedback(){
                var email = $('#emailFeedBack').val();
                var content = $('#textArea').val();
                if(this.validateEmail(email)){
                    if(content != undefined && content != null && content != ''){
                        this.onRequest = true;
                        var body = {
                            feedback_id: this.feedbackId,
                            email: email,
                            content: content,
                            feedback_receiver_email: this.whitelabeling_data.feedback_content_email
                        }

                        this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/enterprise/feedback/sent', body)
                            .then(response => {
                                this.feedbackId = null;
                                this.hideModal();
                                this.onRequest = false;
                                this.$toasted.show("Feedback sent", {
                                    position: "bottom-center",
                                    duration: 5000,
                                    type: 'success'
                                });
                            }, response => {
                                this.onRequest = false;
                                this.$toasted.show("Feedback could not sent", {
                                    position: "bottom-center",
                                    duration: 5000,
                                    type: 'error'
                                });
                            });
                    }else{
                        this.$toasted.show("Feedback content must not be empty!", {
                            position: "bottom-center",
                            duration: 5000,
                            type: 'error'
                        });
                    }
                }else{
                    this.$toasted.show("Please check the E-Mail input!", {
                        position: "bottom-center",
                        duration: 5000,
                        type: 'error'
                    });
                }
            },
            validateEmail(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            saveFeedbackLog(){
                var content = $('#textArea').val();
                if(this.lastContentLength < content.length){
                    if(content.length % 10 == 0){
                        this.saveFeedback();
                    }
                }
                this.lastContentLength = content.length;
            },
            saveFeedback(){
                var requestUrl = '';
                if(this.feedbackId == null){
                   requestUrl = '/enterprise/feedback/insert';
                }else{
                    requestUrl = '/enterprise/feedback/update';
                }
                var body = {
                    feedback_id: this.feedbackId,
                    email: $('#emailFeedBack').val(),
                    content: $('#textArea').val()
                }
                this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + requestUrl, body)
                    .then(response => {
                        if(response.data.data[0].hasOwnProperty('feedback_id')){
                            this.feedbackId = response.data.data[0].feedback_id;
                        }
                    }, response => {
                    });
            },
            searchFaq(){
                var content = $('#textArea').val();
                this.relatedFaqs = new Array();
                if(content.length > 2){
                    var matchedFAQMap = {};
                    var contentParts = content.split(" ");
                    for(var i=0; i<this.faqs.length; i++){
                        for(var j=0; j<contentParts.length; j++){
                            var searchWord = contentParts[j].trim().toLowerCase();
                            if(searchWord != undefined && searchWord != null
                                && searchWord.length > 2 && this.faqs[i].toLowerCase().indexOf(searchWord) != -1){
                                if(!matchedFAQMap.hasOwnProperty(this.faqs[i])){
                                    var questionAnswer = this.faqs[i].split('-');
                                    var obj = {
                                        question: questionAnswer[0],
                                        answer: questionAnswer[1]
                                    }
                                    this.relatedFaqs.push(obj);
                                    matchedFAQMap[this.faqs[i]] = true;
                                }

                            }
                        }
                    }
                }
                if(this.relatedFaqs.length > 0){
                    this.faqFound = true;
                }else{
                    this.faqFound = false;
                }
            }
        },
        computed: {
            ...mapGetters([
                "getWhiteLabelingData"
            ])
        },
        mounted() {
            $('#feedbackModal').modal({show: false});
            this.whitelabeling_data = this.getWhiteLabelingData;
        }
    }
</script>

<style scoped>

    #faqInfo {
        margin-left: 15px;
        margin-top: 15px;
        color: darkgrey;
    }

    #faq-container {
        width: 100%;
        height: 82.5%;
        border: 1px solid #C7C7C7;
        overflow: auto;
    }


    #textArea{
        width: 100%;
        margin-top: 1%;
        margin-bottom: 1%;
        overflow-x: hidden;
        border: 1px solid #C7C7C7;
    }

    #rightDiv{
        height: 95%;
        width: 47%;
        overflow: hidden;
        position: absolute;
        top: 2%;
        right: 2%;
    }

    #leftDiv{
        height: 95%;
        width: 47%;
        position: absolute;
        top: 2%;
        left: 2%;
        overflow: hidden;
    }

    #emailLabel{
        margin-right: 1%;
        font-size: 13px;
        float: left;
    }

    #emailFeedBack{
        width: 100%;
        font-size: 13px;
        border: 1px solid #C7C7C7;
    }

    #emailInputSpan {
        overflow: hidden;
        display: block;
    }

    .question{
        color: limegreen;
        font-size: x-large;
    }

    .questionMark{
        /*background: url("../images/questionmark.png") no-repeat center -6.9rem transparent;*/
        background-size: 2rem;
        min-width: 4rem;
        height: 4rem;
        display: inline-block;
        float: left;
        margin-right: 2%;
    }

    li {
        list-style-type: none;
        margin-left: 1%;
    }

    #send-feedback-button{
        background-color: limegreen;
        border:none;
        height: 50px;
        width: 200px;
        color: white;
        padding: 0 15px;
        font-family: 'Digital-Serial-Bold' !important;
        position: absolute;
        left: calc(49% - 200px);
        bottom: 2%;
        font-size: large;
    }

    #close-button {
        background-color: rgba(255, 0, 67, 1);
        border:none;
        height: 50px;
        width: 100px;
        color: white;
        padding: 0 15px;
        font-family: 'Digital-Serial-Bold' !important;
        position: absolute;
        right: 2%;
        bottom: 2%;
        font-size: large;
    }

    .modal-dialog {
        height: 90% !important;
        width: 80% !important;
    }

    .modal-content {
        height: 100% !important;
        background-color: white !important;
        position: relative;
    }

    h1{
        color: limegreen;
        font-family: 'Digital-Serial-Bold' !important;
    }

    p, label{
        font-family: 'Digital-Serial-Bold' !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/modals/FeedbackModal.vue